export default __webpack_public_path__ + "src/images/btn_enter_system/0-b46dcf.png";